import { AccountInfo } from '@azure/msal-browser';

import { getMsalClient } from '../client';

export const signOut = async (account: AccountInfo): Promise<void> => {
  await getMsalClient().logoutRedirect({ account });
};
